import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class HlrContextService {

    constructor(private api: ApiService) { }

    getContexts(): Observable<any> {
        return this.api.get('vna/hlr/context');
    }

    getContext(pk: number): Observable<any> {
        return this.api.get('vna/hlr/context/' + pk);
    }

    createContext(data: Object): Observable<any> {
        return this.api.post('vna/hlr/context', data);
    }

    updateContext(data: Object, pk: number): Observable<any> {
        return this.api.put('vna/hlr/context', pk, data);
    }

    deleteContext(pk: number): Observable<any> {
        return this.api.remove('vna/hlr/context', pk);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/hlr/services/hlr-context.service.ts